import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';

const FormErrorMessageStyle = () => css`
  color: #f00;
  line-height: 20px;
`;

const FormErrorMessage = styled.span`
  ${FormErrorMessageStyle}
  ${mq({
    fontSize: ['9px', '9px', '10px', '12px'],
    marginTop: ['10px', '0px'],
  })};
`;

export default FormErrorMessage;
